<template lang="html">
	<wizard-screen
		panel-class="omapi-panel__4-2"
		:completed="4"
		:total="5"
		:nav-next="!showUpsell"
		nav-next-text="Continue"
	>
		<h2>Confirm Options</h2>
		<div v-if="showUpsell" class="omapi-happy-text">
			The solutions you selected are only available in OptinMonster Pro.
		</div>
		<div v-else class="omapi-happy-text">The following features have been added to your account.</div>

		<core-loading v-if="isLoading" size="40px" />
		<div v-else>
			<wizard-feature v-for="feature in proFeatures" :key="feature.slug" :feature="feature" />
		</div>

		<div v-if="showUpsell" class="omapi-box__gray">
			<h3>Upgrade to OptinMonster Pro Today and Save 35%!</h3>
			<p>
				When you upgrade to Pro, you'll get instant access to all this, plus 25,000 pageviews, Unlimited
				Campaigns, Countdown Timers, Device Targeting, Campaign Scheduling, Subaccounts and much more!
			</p>
			<div class="omapi-box__gray-buttons">
				<core-upgrade-button
					class="omapi-button omapi-wizard-forward omapi-button__green"
					utm-medium="Wizard"
					:features="extraFeatures"
					@click="$bus.$emit('onboardingNextPage')"
				>
					Upgrade Now &amp; Save 35%
				</core-upgrade-button>
				<core-button
					class="omapi-button omapi-button__grey-light"
					@click.prevent="$bus.$emit('onboardingNextPage')"
				>
					Continue for free
				</core-button>
			</div>
		</div>
	</wizard-screen>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	data () {
		return {
			isLoading : false,
		}
	},
	computed : {
		...mapState([ 'apiKey' ]),
		...mapGetters([ 'showProUpsells' ]),
		...mapGetters('wizard', [ 'proFeatures', 'inExtraFeatures' ]),
		...mapState('plugins', [ 'plugins' ]),
		...mapGetters('plugins', [ 'byId' ]),
		pluginIds () {
			return this.featureMap.filter(f => {
				return f.plugin && this.inExtraFeatures(f.slug)
			}).map(feature => {
				return feature.plugin.slug
			})
		},
		showUpsell () {
			return this.proFeatures.find(f => {
				const feature = f.featureId || f.slug
				return !this.$store.getters.hasFeature(feature) && !this.$store.getters.hasRuleType(feature)
			})
		},
	},
	mounted () {
		if (!this.extraFeatures.length) {
			return this.skip()
		}

		if (this.pluginIds.length && this.apiKey) {
			this.isLoading = true
			this.fetchPlugins().then(this.activatePlugins)
		}
	},
	methods : {
		...mapActions('plugins', {
			fetchPlugins : 'fetch',
			pluginAction : 'action',
		}),
		activatePlugins () {
			if (!this.pluginIds.length) {
				this.isLoading = false
				return
			}

			const actionPromises = []

			this.pluginIds.forEach((pluginId) => {
				const promise = this.pluginAction(pluginId)
					.catch((error) => {
						if (!error.explanation) {
							const plugin = this.byId(pluginId)
							// eslint-disable-next-line no-console
							console.error(`Could not install/activate ${plugin ? plugin.name : pluginId}`, { error })
						}
					})
				actionPromises.push(promise)
			})

			Promise.all(actionPromises)
				.then(() => {
					this.isLoading = false
					if (this.extraFeatures.length === this.pluginIds.length) {
						return this.skip()
					}
				})
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/variables';
.omapi-screen .omapi-panel__4-2 {
	.omapi-box__gray {
		margin: 50px 0 33px;
		p {
			font-size: 14px;
			margin-bottom: 10px;
		}

		&-buttons {
			display: flex;
			justify-content: space-between;
			padding-top: 10px;
			gap: 20px;

			.omapi-button {
				width: 50%;
				text-align: center;
				font-size: 16px;
				padding: 16px 0;

				&__grey-light {
					background-color: #dcdde1; // Gainsboro color with bluish light grey shade
					border-color: #dcdde1;
					color: $color_black;

					&:hover {
						background-color: $color_grey-border;
						border-color: $color_grey-border;
						color: $color_black;
					}
				}
			}
		}
	}

	.omapi-feature:last-child {
		.omapi-checkbox {
			border-bottom: 0 !important;
		}
	}
}
</style>
